import { getConfig } from "../_metronic/i18n";

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken, user },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `${authToken}`;
      }
      config.headers.language = getConfig().selectedLang;

      return config;
    },
    (err) => Promise.reject(err)
  );
}
